import { Guid } from "@fitscovery/common/types";

export namespace PartnerPaymentsActions {

  export class GetPaymentMethods {
    static readonly type = '[PartnerPayments] GetPaymentMethods';
    constructor() { }
  }

  export class GetPartnerPaymentMethods {
    static readonly type = '[PartnerPayments] GetPartnerPaymentMethods';
    constructor(public partnerId: Guid) { }
  }
  
  export class UpdatePartnerPaymentMethods {
    static readonly type = '[PartnerPayments] UpdatePartnerPaymentMethods';
    constructor(public partnerId: Guid, public paymentMethodIds: string[]) { }
  }

}
